import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractColumnTemplate from "./AbstractColumnTemplate.js";
import SeparatorColumn from "../../reports/columns/SeparatorColumn.js";

/**
 * Empty column template, used as a separator.
 *
 * @param {boolean} [spec.narrow = true] - Whether the column should have
 *   the width of a regular column.
 * @param {boolean} [spec.borderOnly = false] - When enabled, the separator
 *   column will be only render as a border, and no extra space will be added.
 *   This can be done by adding a border to the previous column, but the
 *   last one.
 */
export default class SeparatorColumnTemplate extends AbstractColumnTemplate {
	constructor({ narrow = true, borderOnly = false } = {}) {
		super(...arguments);

		this._narrow = narrow;
		this._borderOnly = borderOnly;
	}

	setNarrow(value) {
		this._narrow = value;
	}

	isNarrow() {
		return this._narrow;
	}

	accept(visitor) {
		return visitor.visitSeparatorColumnTemplate(this);
	}

	_instanceClass() {
		return SeparatorColumn;
	}

	_interpretationSpec() {
		const spec = super._interpretationSpec(...arguments);

		spec.narrow = this._narrow;
		spec.borderOnly = this._borderOnly;

		return spec;
	}

	_serializedProperties() {
		const properties = super._serializedProperties(...arguments);

		properties.isNarrow = this._narrow;
		properties.isBorderOnly = this._borderOnly;

		return properties;
	}

	static getLabel() {
		return _("Separator");
	}

	static getType() {
		return "SeparatorColumnTemplate";
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.narrow = data.isNarrow;
		data.borderOnly = data.isBorderOnly;
	}
}
